/* eslint-disable */
// NOTE: This are for SI, and should be OK to have at least as some kind of base... 20250402:Alevale
// NOTE: If you want to log in for other environments paste here the contents of what window.awsConfig is in that environment 20250424:Alevale
export default {
    Auth: {
        AZSignOutURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
        Cognito: {
            authenticationFlowType: 'CUSTOM_AUTH',
            idp: 'Auth0',
            loginWith: {
                oauth: {
                    domain: 'dev-emea.auth.eu-central-1.amazoncognito.com',
                    redirectSignIn: [
                        'http://localhost:8080/apps/portal/login',
                        'http://localhost:8081/apps/portal/login',
                        'http://localhost:8082/apps/portal/login',
                        'https://si.connect.medtronic.com/apps/portal/login',
                        'https://si.emea.connect.medtronic.com/apps/portal/login',
                    ],
                    redirectSignOut: [
                        'http://localhost:8080/apps/portal/logout',
                        'http://localhost:8081/apps/portal/logout',
                        'http://localhost:8082/apps/portal/logout',
                        'https://si.connect.medtronic.com/apps/portal/logout',
                        'https://si.emea.connect.medtronic.com/apps/portal/logout',
                    ],
                    responseType: 'code',
                    scopes: ['email', 'openid', 'phone', 'profile'],
                },
            },
            mandatorySignIn: false,
            region: 'eu-central-1',
            signUpVerificationMethod: 'code',
            userPoolClientId: '3ksh95e5n5079l24shej6m6b2l',
            userPoolId: 'eu-central-1_zsIV2acjv',
        },
        accessTokenTimeout: 5,
        createAcntLink:
            'https://myprofile-test.medtronic.com/registration/api/v1/signup?client_id=yymIaLgXbeSgaQd3LEd8LajUG9dKYlZ0',
        externalSignOutURL: 'https://signin-test.medtronic.com/v2/logout',
    },
};

// UAT
// export default {
//     Auth: {
//         AZSignOutURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
//         Cognito: {
//             authenticationFlowType: 'CUSTOM_AUTH',
//             loginWith: {
//                 oauth: {
//                     domain: 'auth.uat.emea.cloud.connect.medtronic.com',
//                     redirectSignIn: [
//                         'http://localhost:8080/apps/portal/login',
//                         'http://localhost:8081/apps/portal/login',
//                         'http://localhost:8082/apps/portal/login',
//                         'https://uat.connect.medtronic.com/apps/portal/login',
//                     ],
//                     redirectSignOut: [
//                         'http://localhost:8081/apps/portal/logout',
//                         'https://uat.connect.medtronic.com/apps/portal/logout',
//                     ],
//                     responseType: 'code',
//                     scopes: ['email', 'openid', 'phone', 'profile'],
//                 },
//             },
//             mandatorySignIn: false,
//             region: 'eu-central-1',
//             signUpVerificationMethod: 'code',
//             userPoolClientId: '54lhffggb4ddh69147rk35856m',
//             userPoolId: 'eu-central-1_MuwQDDQLv',
//         },
//         accessTokenTimeout: 5,
//         createAcntLink:
//             'https://myprofile-stage.medtronic.com/registration/api/v1/signup?client_id=<UAT_EMEA_AUTH0_CLIENT_ID>',
//         externalSignOutURL: 'https://signin-stage.medtronic.com/v2/logout',
//     },
// };

// SI.US
// export default {
//     Auth: {
//         AZSignOutURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
//         Cognito: {
//             authenticationFlowType: 'CUSTOM_AUTH',
//             loginWith: {
//                 oauth: {
//                     domain: 'dev-us.auth.us-east-1.amazoncognito.com',
//                     redirectSignIn: [
//                         'http://localhost:8080/apps/portal/login',
//                         'http://localhost:8081/apps/portal/login',
//                         'http://localhost:8082/apps/portal/login',
//                         'https://si.us.connect.medtronic.com/apps/portal/login',
//                     ],
//                     redirectSignOut: [
//                         'http://localhost:8080/apps/portal/logout',
//                         'http://localhost:8081/apps/portal/logout',
//                         'http://localhost:8082/apps/portal/logout',
//                         'https://si.us.connect.medtronic.com/apps/portal/logout',
//                     ],
//                     responseType: 'code',
//                     scopes: ['email', 'openid', 'phone', 'profile'],
//                 },
//             },
//             mandatorySignIn: false,
//             region: 'us-east-1',
//             signUpVerificationMethod: 'code',
//             userPoolClientId: '7pgmv8vtls8v625o861cdotu6q',
//             userPoolId: 'us-east-1_w4WQZQFQR',
//         },
//         accessTokenTimeout: 5,
//         createAcntLink:
//             'https://myprofile-test.medtronic.com/registration/api/v1/signup?client_id=<SI_US_AUTH0_CLIENT_ID>',
//         externalSignOutURL: 'https://signin-test.medtronic.com/v2/logout',
//     },
// };

// UAT.US
// export default {
//     Auth: {
//         AZSignOutURL: 'https://login.microsoftonline.com/common/oauth2/v2.0/logout',
//         Cognito: {
//             authenticationFlowType: 'CUSTOM_AUTH',
//             loginWith: {
//                 oauth: {
//                     domain: 'auth.uat.us.cloud.connect.medtronic.com',
//                     redirectSignIn: [
//                         'http://localhost:8080/apps/portal/login',
//                         'http://localhost:8081/apps/portal/login',
//                         'http://localhost:8082/apps/portal/login',
//                         'https://uat.us.connect.medtronic.com/apps/portal/login',
//                     ],
//                     redirectSignOut: [
//                         'http://localhost:8081/apps/portal/logout',
//                         'https://uat.us.connect.medtronic.com/apps/portal/logout',
//                     ],
//                     responseType: 'code',
//                     scopes: ['email', 'openid', 'phone', 'profile'],
//                 },
//             },
//             mandatorySignIn: false,
//             region: 'us-east-1',
//             signUpVerificationMethod: 'code',
//             userPoolClientId: '6k8uoe5hlv93devj8h364mj647',
//             userPoolId: 'us-east-1_lWxXiiGpS',
//         },
//         accessTokenTimeout: 5,
//         createAcntLink:
//             'https://myprofile-stage.medtronic.com/registration/api/v1/signup?client_id=<UAT_US_AUTH0_CLIENT_ID>',
//         externalSignOutURL: 'https://signin-stage.medtronic.com/v2/logout',
//     },
// };
